
import Vue from 'vue';
import { mapActions } from 'vuex';
import { RunnitDynamicFieldMixin } from '@/views/Runnits/RunnitSettings/mixins/RunnitDynamicFieldMixin';
import RunnitModelsDialog from '../base/RunnitModelsDialog.vue';
import RunnitImage from "@/views/Runnits/RunnitImage.vue";
import { db } from "@/firebase";
import { Avatar, Model } from "@run-diffusion/shared";

export default Vue.extend({
	name: 'RunnitModelSelector',
	mixins: [
		RunnitDynamicFieldMixin,
	],
	props: {
		value: { type: [Object, String], default: null },
		field: { type: Object, required: true },
	},
	data () {
		return {
			open: false,
		};
	},
	computed: {
		fieldDisplayArchitecture() {
			return this.field.display?.architecture;
		},
	},
	watch: {
		value: {
			immediate: true,
			async handler (newVal) {
				if (!newVal) {
					return
				}

				if (typeof newVal.model === 'string') {
					try {
						const modelId = newVal.model;
						const modelSnapshot = await db.doc(`models/${modelId}`).get();
						const modelData: Model = {
							...modelSnapshot.data(),
							get id () { return modelId },
						} as Model;

						if (modelSnapshot.exists && modelData) {
							const avatarSnapshot = await db.doc(`avatars/${modelData.avatarId}`).get();
							modelData.avatar = avatarSnapshot.data() as Avatar;
							this.onModelSelect(modelData);
						} else {
							this.onModelSelect(null);
						}
					} catch (error) {
						console.error('Error getting model', error);
						this.onModelSelect(null);
					}
				}
			},
		},
		'$store.state.triggers.promptSelectedModelChangeTrigger': {
			immediate: true,
			handler (newVal: { model: Model, trigger: number }, oldVal: { model: Model, trigger: number }) {
				if (newVal.trigger > 0 && newVal !== oldVal) {
					// Skip if no model
					if (!newVal.model) {
						// If the model is cleared in the store but we still have a model selected,
						// clear our local model as well
						if (this.value && this.value.model) {
							this.$emit('input', { model: null });
						}
						return;
					}

					// Skip if this component already has this model selected
					if (this.value && this.value.model && this.value.model.id === newVal.model.id) return;

					// Just update our component with the new model
					this.$emit('input', { model: newVal.model });
				}
			},
		},
	},
	methods: {
		...mapActions([
			'incrementPromptSelectedModelChangeTrigger',
		]),
		onOpenDialog () {
			this.open = true;
		},
		onModelSelect (model) {
			this.$emit('input', { model });

			// Update the store with the selected model
			if (model) {
				this.incrementPromptSelectedModelChangeTrigger({ model });
			} else {
				// Clear the model if no model selected
				this.incrementPromptSelectedModelChangeTrigger({ model: null });
			}
		},
	},
	components: {
		RunnitImage,
		RunnitModelsDialog,
	},
});
